<template>
  <div v-if="showScanMessage()" class="scanMessage theme-group-3">
    <p>Scan the barcode to add an item to cart</p>
    <app-button text="Scan items" :aria-label="'Scan items'" :handler="openScanModal" />
  </div>
</template>

<script>
import ScanAndGoMixin from "@/mixins/scan-and-go.mixin";

export default {
  name: "ScanAndGoMessages",
  mixins: [ScanAndGoMixin]
};
</script>

<style scoped lang="scss">
.scanMessage {
  width: 100%;
  display: flex;
  margin: 0px auto 8px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
  padding: 11px 0 $spacer;
  justify-content: space-evenly;
  align-items: center;
  flex-shrink: 0;
  order: 0;

  & > p {
    margin: 0 $spacer 0px ($spacer * 1.5);
  }

  button {
    border-radius: 20px;
    height: 35px;
    font-size: 14px;
    min-width: 150px;
    width: initial;
    margin-right: ($spacer * 1.5);
  }
}
</style>
